import React, { PropTypes } from 'react';
import { Accordion, Form, Icon, Input } from 'semantic-ui-react';
import ReferenceDropdown from 'common/components/ReferenceDropdown';
import MultiReferenceCheckbox from 'common/components/MultiReferenceCheckbox';

class Site extends React.Component {
  render() {
    const {
      site,
      siteInfos,
      workers,
      securityEpis,
      inventoryToPlan,
      handleClick,
      index,
      currentIndex,
    } = this.props;
    const active = currentIndex === index;

    const onValueChanged = propName => (evt, data) => {
      this.props.onChange(propName, data.value);
    };

    const workersToRef = workers.map(w => ({
      id: w.id,
      label: w.display_name,
    }));

    return (
      <div>
        <Accordion.Title
          active={active}
          index={index}
          onClick={handleClick}
          style={{ position: 'relative', color: 'black' }}
        >
          <Icon name="dropdown" />
          Site : {site.name}
        </Accordion.Title>
        <Accordion.Content active={active}>
          <Form>
            <Form.Group>
              <Form.Field width={10}>
                <label>Commentaire général</label>
                <Input
                  value={siteInfos.info_comment || ''}
                  onChange={onValueChanged('info_comment')}
                />
              </Form.Field>
              <ReferenceDropdown
                refs={workersToRef}
                onChange={onValueChanged('ref_tech_id')}
                title="Technicien référent"
                value={siteInfos.ref_tech_id}
                width="6"
              />
            </Form.Group>
            <Form.Field>
              <label>Contrainte de planification</label>
              <Input
                value={siteInfos.planif_constraint || ''}
                onChange={onValueChanged('planif_constraint')}
              />
            </Form.Field>
            <MultiReferenceCheckbox
              label="Matériel à prévoir"
              values={siteInfos.inventory_to_plan}
              references={inventoryToPlan}
              onChangeValues={onValueChanged('inventory_to_plan')}
              onChangeOther={() => {}}
            />
            <MultiReferenceCheckbox
              label="EPI adaptés"
              values={siteInfos.security_epis}
              references={securityEpis}
              onChangeValues={onValueChanged('security_epis')}
              onChangeOther={() => {}}
            />
            <Form.Group widths="equal">
              <Form.Field>
                <label>Conditions financières</label>
                <Input
                  value={siteInfos.financial_condition || ''}
                  onChange={onValueChanged('financial_condition')}
                />
              </Form.Field>
              <Form.Field>
                <label>Prix</label>
                <Input
                  value={siteInfos.price || ''}
                  onChange={onValueChanged('price')}
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Accordion.Content>
      </div>
    );
  }
}

Site.propTypes = {
  site: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  siteInfos: PropTypes.object.isRequired,
  securityEpis: PropTypes.array.isRequired,
  workers: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
};

export default Site;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/components/Site.js